import { render, staticRenderFns } from "./DropoutReminder.vue?vue&type=template&id=2b817091&"
import script from "./DropoutReminder.vue?vue&type=script&lang=js&"
export * from "./DropoutReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports